export default __webpack_public_path__ + "img/856da2913503b12df73e059815ff1b1d.png";